import {
    Grid,
    TextField,
} from '@material-ui/core';
import {
    createStyles, makeStyles,
    Theme
} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Button } from '@material-ui/core';
import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import styled from 'styled-components';
import './NewBooking.css'
import { getPackage, getLabCredential, getDisplayCities } from "../../../actions/OffLineSupportActions";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        content: {
            width: "80%",
            flexGrow: 21,
        },
        paper: {
            marginTop: "2rem",
            padding: "0.5rem 2rem 2rem 2rem",
            width: "100%",
        },
        hoveItem: {
            cursor: "pointer",
        },

        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        root1: {
            // backgroundColor: "#fa4d83",

        },
        toolbar: {
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(4, 4),
            ...theme.mixins.toolbar,
        },
    })
);
const GlassContainer = styled.div`
    background: linear-gradient(147deg, #c3cbdc 0%, #edf1f4 74%);
    backdrop-filter: blur(10px);
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const BodyContainer = styled.body`
    background-color: #ffffff;
    background-image: linear-gradient(315deg, #ffffff 0%, #274060 74%);
    height: 100vh;
    margin: 0; 
    display: flex;
    align-items: center;
    justify-content: center;
`;
interface Props {
    getPackage: any;
    packageList: any;
    getLabCredential: any;
    labCredential: any;
    getDisplayCities: any;
    displayCities: any;
}
const StopsPlace: React.FC<Props> = ({
    getPackage,
    packageList,
    getLabCredential,
    labCredential,
    getDisplayCities,
    displayCities,


}) => {
    const classes = useStyles();
    const [pincode, setPincode] = useState<any>("");
    const { _id } = useParams<{ _id: string }>();
    const [labName, setLabName] = useState<any>("")
    const [lab, setLab] = useState<any>("")
    const [test, setTest] = useState<any>("")
    const [city, setCity] = useState<any>("")
    const [packages, setPackages] = React.useState<any>([]);
    const [cityName, setCityName] = useState<any>("")
    const [autocompleteKey, setAutocompleteKey] = useState(0);
    const timer = useRef<any>(0);
    const history = useHistory()
    const goforbooking = () => {
        history.push("/dashboard/os/create_newbooking")
    }

    useEffect(() => {
        getPackage();
        getDisplayCities();
    }, [])


    return (
        <BodyContainer style={{ width: "100%", marginTop: "30px" }}>
            <GlassContainer >
                <div className={classes.root}>
                    <div className={classes.toolbar} />
                    <h3 style={{ fontWeight: "bold", textAlign: "center", marginTop: "-40px" }}>ESTIMATE</h3>
                    <hr />
                    <form style={{ width: "100%", marginLeft: "4px" }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4}>
                                <TextField
                                    label="Search Area by Pincode"
                                    variant="outlined"
                                    className="input"
                                    placeholder="Enter Pincode/Area Name"
                                    fullWidth
                                    value={pincode}
                                    onChange={(e) => setPincode(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={4}>
                                <Autocomplete
                                    id="cityname"
                                    onChange={(event, newValue) => {
                                        let cName: any = "";
                                        if (newValue) {
                                            let obj = JSON.parse(
                                                JSON.stringify(newValue, null, " ")
                                            );
                                            cName = obj;
                                        }
                                        setCityName(cName);
                                    }}
                                    options={displayCities.cities || []}
                                    freeSolo
                                    blurOnSelect
                                    inputValue={cityName ? cityName : ""}
                                    onInputChange={(event, newInputValue) => {
                                        setCityName(newInputValue);
                                    }}
                                    aria-required
                                    limitTags={1}
                                    getOptionLabel={(option: any) => option}
                                    // getOptionDisabled={(option: any) => {
                                    //     const cName = displayCities.cities.indexOf(
                                    //         booking.display_name
                                    //     );

                                    //     return option === displayCities.cities[cName];
                                    // }}
                                    disableCloseOnSelect
                                    renderInput={(params) => (
                                        <TextField
                                            className="input"
                                            {...params}
                                            label="City Name"
                                            variant="outlined"
                                            style={{ width: "100%", margin: "0", padding: "0" }}
                                            inputProps={{
                                                ...params.inputProps,
                                                onKeyDown: (e) => {
                                                    if (e.key === 'Enter') {
                                                        e.stopPropagation();
                                                    }
                                                },
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={4}>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            let obj = JSON.parse(
                                                JSON.stringify(newValue, null, " ")
                                            );
                                            setLab(obj.id);
                                        }
                                    }}
                                    inputValue={labName}
                                    onInputChange={(event, newInputValue) => {
                                        setLabName(newInputValue);
                                        clearTimeout(timer.current);
                                        timer.current = setTimeout(() => {
                                            getLabCredential(`?name=${newInputValue}`);
                                        }, 1000);

                                        if (newInputValue.length === 0) {
                                            setLab("");
                                        }
                                    }}
                                    options={labCredential.results || []}
                                    freeSolo
                                    blurOnSelect
                                    aria-required
                                    getOptionLabel={(option: any) => `${option?.name}`}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            className="input"
                                            label="Lab Name"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    key={autocompleteKey}
                                    id="customerPackage"
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            let packs: any = [];
                                            newValue.map((val: any) => {
                                                let obj = JSON.parse(JSON.stringify(val, null, " "));
                                                packs.push(obj);
                                            });
                                            setPackages(packs);
                                        }
                                    }}
                                    multiple
                                    disableClearable
                                    freeSolo
                                    options={packageList?.results || []}
                                    limitTags={0}
                                    disableCloseOnSelect
                                    onInputChange={(event, newInputValue) => {
                                        clearTimeout(timer.current);
                                        timer.current = setTimeout(() => {
                                            getPackage();
                                        }, 1000);
                                    }}
                                    getOptionLabel={(option: any) =>
                                        option?.name + "(" + option?.code + ")"
                                    }
                                    getOptionDisabled={(option: any) => {
                                        const packID = packages.map((pack: any) => pack.code);
                                        return packID.includes(option.code);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            className={classes.input}
                                            placeholder="Search & Select Test Name/Code"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </form>
                    <div className="divColor" style={{ marginTop: "5px", padding: "4px" }}>
                        <table style={{ width: "100%", margin: "0" }}>
                            <thead>
                                <tr>
                                    <td className="cell" align="center">
                                        S No.
                                    </td>
                                    <td className="cell" align="center">
                                        Test Code
                                    </td>
                                    <td className="cell" align="center">
                                        Test Name
                                    </td>
                                    <td className="cell" align="center">
                                        PRICE
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                {packages &&
                                    packages.length > 0 &&
                                    packages.map((packageItem: any, index: number) => (
                                        <tr>
                                            <td className="cell" align="center">
                                                {index + 1}
                                            </td>
                                            <td className="cell" align="center">
                                                {packageItem?.code}
                                            </td>
                                            <td className="cell" align="center">
                                                {packageItem?.name}
                                            </td>
                                            <td className="cell" align="center">
                                                {Number(packageItem?.offer_price).toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}
                                <tr>
                                    <td className="cell" align="left">
                                    </td>
                                    <td className="cell" align="left">
                                    </td>
                                    <td className="cell" align="center">
                                        Total
                                    </td>
                                    <td className="cell" align="center">
                                        ₹ 50
                                    </td>
                                </tr>

                            </tbody>
                            {/* <tbody>
                                {packages &&
                                    packages.length > 0 &&
                                    packages.map((packageItem: any, index: number) => (
                                        <tr>
                                            <td className="cell" align="center">
                                                {index + 1}
                                            </td>
                                            <td className="cell" align="center">
                                                {packageItem?.code}
                                            </td>
                                            <td className="cell" align="left">
                                                {packageItem?.name}
                                            </td>
                                            <td className="cell" align="center">
                                                {Number(packageItem?.package_lab_prices).toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}
                                <tr>
                                    <td className="cell" align="center" />
                                    <td className="cell" align="left">
                                        Total
                                    </td>
                                </tr>
                            </tbody> */}
                            <Button
                                variant="contained"
                                style={{ marginTop: "4px", background: "linear-gradient(315deg, #70a1ff 0%, #c2c0c0 74%)" }}
                            >
                                Suggested Package
                            </Button>
                        </table>
                    </div>
                    <Grid container spacing={1}>
                        <Grid item xs={9}>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                variant="contained"
                                style={{
                                    marginTop: "4px",
                                    background: "linear-gradient(315deg, #44b09e 0%, #e0d2c7 74%)"
                                }}
                                onClick={() => goforbooking()}
                            >
                                Go For Booking
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </GlassContainer>
        </BodyContainer>
    );
};
const mapStateToProps = (state: any) => ({
    packageList: state.OffLineSupporteReducer.packageList,
    labCredential: state.OffLineSupporteReducer.labCredential,
    displayCities: state.OffLineSupporteReducer.displayCities

});
export default connect(mapStateToProps, {
    getPackage,
    getLabCredential,
    getDisplayCities,
})(StopsPlace);
